import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import GetAppIcon from '@material-ui/icons/GetApp';

import Locale from './../../Locale';
import Member from './../../Member';

export default class LeafletAndProvision extends React.Component {
  render() {
    const color = Member.getThemeColor();
    const linkStyle = { ...linkBaseStyle, color };
    const iconStyle = { ...iconBaseStyle, color };

    const leafletUrl = resolveUrl(leafletBaseUrl, this.props.leaflet);
    const provisionUrl = resolveUrl(provisionBaseUrl, this.props.provision);

    return (
      <View style={styles.productDetails}>
        <Text>
          {
            this.props.noPremiumRates ?
              <Text>
                {Locale.text.forDetailsOfTheProductAndExclusions}
              </Text> :
              <Text>
                {Locale.text.forDetailsOfTheProductExclusionsAndPremiumRates}
              </Text>
          }

          <Text>
            {Locale.text.pleaseReferTo}
          </Text>

          {
            this.props.leaflet &&
              <a
                style={linkStyle}
                href={leafletUrl}
                target='_blank'
                rel='noreferrer'
              >
                <GetAppIcon style={iconStyle} />
                {Locale.text.productLeaflet}
              </a>
          }

          {
            this.props.leaflet && this.props.provision &&
              <Text>{Locale.text.productDetailsAnd}</Text>
          }

          {
            this.props.provision &&
              <a
                style={linkStyle}
                href={provisionUrl}
                target='_blank'
                rel='noreferrer'
              >
                <GetAppIcon style={iconStyle} />
                {Locale.text.policyProvision}
              </a>
          }

          <Text>
            {Locale.text.productDetailsPeriod}
          </Text>
        </Text>
      </View>
    );
  }
}

const resolveUrl = (baseUrl, value) => {
  if (!value) {
    return value;
  }
  return value.startsWith('http') ? value : baseUrl + value;
};

const baseUrl = 'https://repository.generali.com.hk/bravo/short/p/share_files/';
const leafletBaseUrl = baseUrl + 'Product_leaflet/';
const provisionBaseUrl = baseUrl + 'Product_provision/';

const styles = StyleSheet.create({
  productDetails: {
    marginTop: 5,
    marginBottom: 5,
  },
});

const linkBaseStyle = {
  fontSize: 16,
  fontWeight: 'bold',
  textDecoration: 'none',
  whiteSpace: 'nowrap',
};

const iconBaseStyle = {
  fontSize: 18,
  verticalAlign: 'middle',
  marginRight: 2,
  marginTop: -2,
};
